/**
 * LegacyTransferNotice — Aviso de descontinuação dos formatos antigos
 * (.uaizyworkspace e .uaizyflow).
 *
 * Exibido nos diálogos legados de exportar/importar workspace e fluxo,
 * direcionando o usuário para a tela unificada de Templates do Sistema.
 *
 * RELEASE: 2026-09-08 v1.0.0 - Criação (Fase 5 do Sistema de Templates)
 */

import { Link } from 'react-router-dom';
import { InlineNotice } from '@/components/ui/inline-notice';

/** Rota da tela unificada de Templates do Sistema */
export const SYSTEM_TEMPLATES_ROUTE = '/tenant/settings/system-templates';

/**
 * Data limite em que os formatos antigos deixam de ser aceitos.
 * Mantida em um único lugar para facilitar a comunicação ao cliente.
 */
export const LEGACY_FORMAT_SUNSET_LABEL = '31/12/2026';

interface LegacyTransferNoticeProps {
  /** Fluxo em que o aviso aparece: exportação ou importação */
  mode: 'export' | 'import';
}

/**
 * Aviso padronizado sobre o período de compatibilidade dos formatos antigos.
 */
export function LegacyTransferNotice({ mode }: LegacyTransferNoticeProps) {
  return (
    <InlineNotice variant="warning">
      Este formato antigo continua funcionando até <strong>{LEGACY_FORMAT_SUNSET_LABEL}</strong>.
      {mode === 'export'
        ? ' Para levar a configuração completa da conta para outro cliente, use '
        : ' Para receber a configuração completa de outra conta, use '}
      <Link to={SYSTEM_TEMPLATES_ROUTE} className="underline font-medium">
        Templates do Sistema
      </Link>
      .
    </InlineNotice>
  );
}
